import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Play;
var _excluded = ["as", "href", "className", "label", "timestampSeconds", "isDark", "children"],
  _excluded2 = ["htmlProps"],
  _excluded3 = ["htmlProps"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"];
import { forwardRef, Fragment } from 'react';
import cn from 'classnames';
import Play from '@crehana/icons/fill/Play';
import { date } from '@crehana/utils';
import Clamp from "../../Clamp";
import parseClassnames from "../../helpers/parseClassnames";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayButton = function PlayButton(_ref, ref) {
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    label = _ref.label,
    timestampSeconds = _ref.timestampSeconds,
    isDark = _ref.isDark,
    children = _ref.children,
    playButtonProps = _objectWithoutProperties(_ref, _excluded);
  var buttonClassNames = parseClassnames(className, cn('w-full sm:w-auto max-w-full h-24 px-8 flex items-center justify-between font-caption text-base-main rounded-5 cursor-pointer', isDark ? 'bg-gray-light' : 'bg-gray-main'));
  var renderContent = function renderContent() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("p", {
        className: "flex items-center",
        children: [_Play || (_Play = /*#__PURE__*/_jsx(Play, {
          size: 16,
          ignoreColor: true,
          className: "mr-4 fill-current stroke-current flex-shrik-0"
        })), /*#__PURE__*/_jsx(Clamp, {
          as: "span",
          clamp: 1,
          className: "break-all",
          children: label
        })]
      }), typeof timestampSeconds === 'number' && /*#__PURE__*/_jsx("span", {
        className: "ml-4 whitespace-no-wrap",
        children: date.toTimestamp(timestampSeconds)
      })]
    });
  };
  if (as === 'a' || href) {
    var _ref2 = playButtonProps,
      _htmlProps = _ref2.htmlProps,
      aProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: buttonClassNames
    }, _htmlProps), aProps), {}, {
      children: renderContent()
    }));
  }
  if (as === 'label') {
    var _ref3 = playButtonProps,
      _htmlProps2 = _ref3.htmlProps,
      labelProps = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: buttonClassNames
    }, _htmlProps2), labelProps), {}, {
      children: renderContent()
    }));
  }
  if (as === 'span') {
    var _ref4 = playButtonProps,
      _htmlProps3 = _ref4.htmlProps,
      spanProps = _objectWithoutProperties(_ref4, _excluded4);
    return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: buttonClassNames
    }, _htmlProps3), spanProps), {}, {
      children: renderContent()
    }));
  }
  var _ref5 = playButtonProps,
    htmlProps = _ref5.htmlProps,
    buttonProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    className: buttonClassNames
  }, htmlProps), buttonProps), {}, {
    children: renderContent()
  }));
};
export default /*#__PURE__*/forwardRef(PlayButton);